module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "head-text"
  }, [_vm._v("\n\t\t远程双录：\n\t")]), _vm._v("\n\t投资者在待合同签署阶段发起远程双录，对和理财师视频对话进行录音录像。双录结束后进行提交上传双录文件。可以投资者自己结束双体提交，也可理财师进行结束提交。\n\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe",
    attrs: {
      "show-indicators": _vm.showindicators,
      "loop": _vm.loopenable
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/record1.png"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/record2.png"),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep,
      "total_step": "02"
    },
    on: {
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_vm._v(_vm._s(_vm.message))])], 1), _vm._v(" "), _c('div', {
    staticClass: "head-text"
  }, [_vm._v("\n\t\t本地双录：\n\t")]), _vm._v("\n\t在待投资者合同签署阶段，由理财师发起本地双录，投资者和理财师同框进行录音、录像。由理财师结束录制上传双录文件 \n\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe1",
    attrs: {
      "show-indicators": _vm.showindicators,
      "loop": _vm.loopenable
    },
    on: {
      "change": _vm.onChange1
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/record_local1.png"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/record_local2.png"),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep1,
      "total_step": "02"
    },
    on: {
      "leftClick": _vm.leftClick1,
      "rightClick": _vm.rightClick1
    }
  }, [_vm._v(_vm._s(_vm.message1))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fe2f0b4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Guide/recordGuide.vue
// module id = 1062
// module chunks = 1